function ManualInput() {
    /// <summary>
    /// This object provides common functions for the Widget.Input.Template.vb <br/>
    /// Author: ARF<br />
    /// Date: 15.3.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 4.4.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.LastDay = null;
    this.wizard = null;
    this.isMeterReading = false;
}
ManualInput.prototype = new vcTemplate();

ManualInput.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
   var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        if (me.mobile || me.width < 400) {
            me.visual.addClass("mobile");
        }

        //we have to decide wether we are an range-input or an input-reading
        if (me.visual.hasClass("input-reading")) {
            me.isMeterReading = true;
        }


       me.initWizard();

        //optionally load the input log
        me.visual.find("#ddl-signal").off("change").on("change", function () { me.fetchInputLog(); });
        me.fetchInputLog();


        me.visual.find('#div-btn-new').off("click").on("click",
           function () {
               me.wizard.vcWizard("setActive", 1);
               if (me.isMeterReading===false) { me.visual.find("#div-unit").html(me.visual.find("#ddl-signal").find(':selected').data('dims'));}
               me.visual.find("#div-signal-info,#div-menu,#div-back").show();
               me.visual.find("#div-signal,#div-new, #div-list, #div-meter-info").hide();
               me.visual.find("#signal-info").html(me.visual.find("#ddl-signal option:selected").text());
               me.getParam();
           }).button();

        me.visual.find('#div-btn-calculate').off("click").on("click",function () {me.fetchValues();}).button();

        me.visual.find('#div-btn-back').off("click").on("click",
        function () {
            me.visual.find("#div-saved").hide();
            //handle the different steps
            if (me.wizard.vcWizard("getActive") === 1) {
                me.wizard.vcWizard("setActive", 0);
                me.visual.find("#div-menu,#div-data, #div-back,#div-signal-info").hide();
                me.visual.find("#div-new,#div-signal").show();
                if (me.isMeterReading) {
                    me.visual.find("#div-list,#div-meter-info").show();
                }

            }
            if (me.wizard.vcWizard("getActive") === 2) {
                me.wizard.vcWizard("setActive", 1);
                me.visual.find("#div-menu,#div-signal-info").show();
                me.visual.find("#div-data").hide();
            }
        }).button();


        me.visual.find('#chb-delete-archive').off("click").on("click",
            function() {
                if ($(this).prop("checked")) {
                    me.visual.find("#div-btn-save").button("enable");
                    me.visual.find("#div-delete-archive").removeClass("error");
                    return true;
                } else {
                    me.visual.find("#div-btn-save").button("disable");
                    me.visual.find("#div-delete-archive").addClass("error");
                    return true;
                }
            });

        me.initCalendar(me.visual.find('.calendar-input'));
        //always generate the parameter and validate the values
        me.visual.find('#txt-date, #txt-date-start').datepicker( "option", "onSelect",  function() { me.getParam(); });

        //always generate the parameter and validate the values
        me.visual.find("input.startType").off("click").on("click", function () {
            me.visual.find("input.startType").prop("checked", false);
            $(this).prop("checked", true);
            me.getParam();
            return true;
        });


        //always generate the parameter and validate the values
        me.visual.find("#ddl-15min, #ddl-15min-start").off("change").on("change", function () { me.getParam(); });

        //show the signal info popup
        me.visual.find(".fa-info-circle").off("click").on("click", function () {
            me.vcVisual.showSignalAnalogSummaryDialog(parseInt(me.visual.find("#ddl-signal").val(), 10));
            return true;
        });

        //add a change event handler with a little delay
       // generate the parameter and validate the values
        var timerid;
        me.visual.find("#txt-value, #txt-last-reading").on("input", function () {
            var value = $(this).val();
            if ($(this).data("lastval") !== value) {
                $(this).data("lastval", value);
                clearTimeout(timerid);
                timerid = setTimeout(function () { me.getParam(); }, 500);
            };
        });

        me.visual.find('#div-btn-save').off("click").on("click", function () {me.save();}).button();

        //reset the height of the optional input log list
        me.visual.find("#div-list").height(parseInt(me.visual.height() - me.visual.find(".vc-wizard").outerHeight() - me.visual.find("#div-meter-info").outerHeight() - me.visual.find("#div-signal").outerHeight() - me.visual.find("#div-new").outerHeight() - 50, 10));

        // generate the parameter and validate the values
        me.getParam();

        return true;
    } catch (ex) {
        me.writeError('init', ex); return false; }
};

ManualInput.prototype.initWizard = function () {
    /// <summary>
    /// This function calculates the width of the single wizard steps and inits the wizard. 
    /// </summary>
    var me = this;
    try {
        me.wizard = me.visual.find("#div-wizard" + me.vcgid).vcWizard({ 'stepWidth': parseInt((me.width - 48) / 3, 10) });
    } catch (ex) { me.writeError('initWizard', ex);  }
};

ManualInput.prototype.getParam = function () {
    /// <summary>
    /// This function generates all necessary data for saving and validating the input data.<br/>
    /// It is used to validate the input before saving anything - therefore this function is called anytime an input field gets changed.
    /// </summary>
    var me = this;
    var param = {};
    var bValid = true;
    var bValidStart = true;
    try {
        if (me.error) { return false; }
        
        me.showInfo("", "", false);

        me.visual.find("#div-negative-value").hide();

        param.Type = 1;
        //validate the input value
        if (me.visual.find("#txt-value").val().length > 0) {
            param.Value = parseFloat(me.visual.find("#txt-value").val().replace(".", "").replace(",", "."));
            me.visual.find("#div-frame-value").removeClass("error");
            me.visual.find("#div-no-value").hide();
        } else {
            me.visual.find("#div-frame-value").addClass("error");
            me.visual.find("#div-no-value").show();
            me.visual.find("#div-btn-calculate").button("disable");
            bValid = false;
        }

        //validate the end date
        param.EndDay = me.visual.find("#txt-date").val();

        if (param.EndDay.length > 0) {
            me.visual.find("#div-frame-date").removeClass("error");
        } else {
            me.visual.find("#div-date-not-empty").hide();
            me.visual.find("#div-frame-date").addClass("error");
            me.visual.find("#div-btn-calculate").button("disable");
            bValid = false;
        }

        //validate the start date
        param.StartType = parseInt(me.visual.find(".startType:checked").data("type"), 10);
        param.StartDay = me.visual.find("#txt-date-start").val();
        if (param.StartType === 1) {
           
            me.visual.find("#div-start-higher-than-end, #div-start-not-empty").hide();
            me.visual.find("#txt-date-start").datepicker("enable");
            me.visual.find("#ddl-15min-start,#txt-last-reading").prop("disabled", "");
            me.visual.find("#txt-last-reading").css("background-color", "#fff");
            if (param.StartDay.length > 0) {
                me.visual.find("#div-no-date-start").hide();
            } else {
                me.visual.find("#div-no-date-start").show();
                me.visual.find("#div-btn-calculate").button("disable");
                bValid = false;
                bValidStart = false;
            }
           //decide which start reading (only if it exists) we want to take
            if (typeof(me.visual.find("#txt-last-reading.input-reading")) !== "undefined") {
                if (me.visual.find("#txt-last-reading").val().length > 0) {
                    param.StartReading = parseFloat(me.visual.find("#txt-last-reading").val().replace(".", "").replace(",", "."));
                    me.visual.find("#div-no-last-reading").hide();
                } else {
                    me.visual.find("#div-no-last-reading").show();
                    me.visual.find("#div-btn-calculate").button("disable");
                    bValid = false;
                    bValidStart = false;
                }
            } else {
                me.visual.find("#div-no-last-reading").hide();
            }

            //validate start and end date
            if (bValid) {
                var diff = parseInt($.datepicker.parseDate('dd.mm.yy', param.EndDay) -
                    $.datepicker.parseDate('dd.mm.yy', param.StartDay),10);
                if (diff <= 0) {
                    me.visual.find("#div-btn-calculate").button("disable");
                    me.visual.find("#div-no-last-reading,#div-no-date-start").hide();
                    me.visual.find("#div-start-higher-than-end").show();
                    bValid = false;
                    bValidStart = false;
                }
            }

        } else {
            me.visual.find("#txt-date-start").datepicker("disable");
            me.visual.find("#ddl-15min-start,#txt-last-reading").prop("disabled", "disabled");
            me.visual.find("#txt-last-reading").css("background-color", "#eee");
            me.visual.find("#div-no-date-start").hide();
            bValidStart = true;
        }


        if (bValidStart === false) {
            me.visual.find("#div-frame-startdate").addClass("error");
            return false;

        } else {
            me.visual.find("#div-frame-startdate").removeClass("error");
        }

        if (bValid === false) {
            return false;
        } else {
            me.visual.find("#div-btn-calculate").button("enable");
        }

        param.EndIndex = parseInt(me.visual.find("#ddl-15min").val(), 10);
        param.Bsaid = parseInt(me.visual.find("#ddl-signal").val(), 10);

        param.StartDay = me.visual.find("#txt-date-start").val();
        param.StartIndex = parseInt(me.visual.find("#ddl-15min-start").val(), 10);

        return param;
    } catch (ex) {
        me.writeError('getParam', ex); return false;
    }
};

ManualInput.prototype.fetchValues = function () {
    /// <summary>
    /// This function sends the parameters to the server which <br/>
    /// calculates all values and validates the settings against existing archive entries. <br/>
    /// If everything is ok, it goes to the 2nd step and shows the values we want to save!
    /// </summary>
    var me = this;
    
    var param;
    try {
        if (me.error) { return false; }

        param = me.getParam();

        if (param === false) {
            return false;
        }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(param),
            function (result) {

                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                }
                if (result === false) {
                    me.showMessage(me.resources.err_loadData,  true);
                } else {
                    if (result.ErrorCode !== -1) {
                        me.visual.find("#div-btn-calculate").button("disable");

                      
                        switch (result.ErrorCode) {
                          
                            case 1: //no start date found
                                me.visual.find("#div-frame-date").addClass("error");
                                me.visual.find("#div-no-date, #div-date-not-empty").hide();
                                me.visual.find("#div-no-data-before-start").show();
                                break;
                           
                            case 2: //archive entries found
                                me.visual.find("#div-frame-value").addClass("error");
                                me.visual.find("#div-no-value").hide();
                                me.visual.find("#div-negative-value").show();
                                break;
                            case 3: //archive entries for the fix start date already exist
                                me.visual.find("#div-frame-startdate").addClass("error");
                                me.visual.find("#div-no-last-reading,#div-no-date-start,#div-start-higher-than-end ").hide();
                                me.visual.find("#div-start-not-empty").show();
                                break;
                            case 4: //archive entries for the fix end date already exist
                                me.visual.find("#div-frame-date").addClass("error");
                                me.visual.find("#div-no-date,#div-no-data-before-start").hide();
                                me.visual.find("#div-date-not-empty").show();
                                break;
                        default:
                        }
                     
                        return false;
                    }
                    me.wizard.vcWizard("setActive", 2);
                    me.visual.find("#div-menu").hide();
                    me.visual.find("#div-data").show();

                    var tmp = "";
                   
                    me.visual.find("#div-from").html(result.FullStartDay);
                    me.visual.find("#div-to").html(result.FullEndDay);

                    // if archive entries exist we ask the user if he wants to delete them
                    // if not we won't save anything
                    if (result.ExistingArchiveEntries !== null) {
                        if (result.ExistingArchiveEntries.rows !== null) {
                            for (var i = 0; i < result.ExistingArchiveEntries.rows.length; i++) {
                                tmp += $.datepicker.formatDate('dd.mm.yy', result.ExistingArchiveEntries.rows[i].day) + ' (' + result.ExistingArchiveEntries.rows[i].counter + 'x)<br/>';
                            }
                            me.visual.find("#div-existing-entries").html(tmp);
                            me.visual.find("#div-archive-entries").show();
                            me.visual.find("#chb-delete-archive").prop("checked", false);
                            me.visual.find("#div-delete-archive").addClass("error");
                            me.visual.find("#div-btn-save").button("disable");
                        } else {
                            me.visual.find("#div-existing-entries").html("");
                            me.visual.find("#div-archive-entries").hide();
                            me.visual.find("#div-delete-archive").removeClass("error");
                            me.visual.find("#div-btn-save").button("enable");

                        }
                    } else {
                        me.visual.find("#div-existing-entries").html("");
                        me.visual.find("#div-archive-entries").hide();
                    }

            
                    if (me.isMeterReading) {
                        if (result.Mkorr !== 1) {
                            me.visual.find("#span-mkorr-info").html(result.Mkorr);
                            me.visual.find("#div-mkorr-info").show();
                        }
                    } else {
                        me.visual.find("#div-mkorr-info").hide();
                    }

                    //let's show everything we got
                    me.visual.find("#div-last-reading").html(Highcharts.numberFormat(result.MeterReading, 2, ',', '.'));
                    
                    var val = parseFloat(me.visual.find("#txt-value").val().replace(".", "").replace(",","."));
                    me.visual.find("#div-input-value").html(Highcharts.numberFormat(val, 2, ',', '.'));

                    if (me.isMeterReading === false) {
                        me.visual.find("#div-input-value").append(' ' + result.Unit);
                    }
                    me.visual.find("#div-new-reading").html(Highcharts.numberFormat(val, 2, ',', '.'));
                    me.visual.find("#div-diff-reading").html(Highcharts.numberFormat(val- result.MeterReading, 2, ',', '.'));
                    me.visual.find("#div-value").html(Highcharts.numberFormat(result.Value, 2, ',', '.') + ' (' + result.Counter + 'x)');
                    me.visual.find("#div-rounding").html(Highcharts.numberFormat(result.RoundingDiff, 2, ',', '.'));
                    me.visual.find("#div-btn-save").button("enable");
                }
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('fetchValues', ex); return true;
    }
};

ManualInput.prototype.save = function () {
    /// <summary>
    /// This function saves the values - very simple as the complete validation has been done already
    /// </summary>
    var me = this;

    var param;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        param = me.getParam();

        if (param === false) {return false; }

        if (param.StartType === 1 && param.StartDay.length === 0) { return true; }
        me.visual.find('#div-btn-save').button("option", "disabled", true);

       
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify(param),
            function (result) {
               
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                   // me.visual.find('#div-btn-save').button("disabled");
                    return true;
                } else {
                    me.visual.find("#div-data").hide();
                    me.visual.find("#div-saved").show();
                    me.fetchInputLog();
                   // me.visual.find('#div-btn-save').button("disabled");
                }
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('save', ex); return true;
    }
};

ManualInput.prototype.fetchInputLog = function () {
    /// <summary>
    /// This function fetches the optional manual input logs as html and shows it - very simple.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ "type": 2, "bsaid": parseInt(me.visual.find("#ddl-signal").val(), 10) }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                me.visual.find("#div-list").html(result);
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('fetchInputLog', ex); return true;
    }
};

ManualInput.prototype.showWarning = function (content) {
    /// <summary>
    /// This function handles specific warning handling. 
    /// </summary>
    var me = this;
    try {
       
        me.visual.find('#info div').removeClass('note').addClass('error').html(content).show();
        me.visual.find('#info').show();
        return true;
    } catch (ex) { me.writeError('showWarning', ex); return false }
};

ManualInput.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-list,#div-new, #div-menu, #div-data, #div-back, #div-next').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


